
import { defineComponent, ref } from "vue";
import printJS from "print-js";
import PdfTemplate from "@/components/print/PdfTemplate.vue";
import PDFGenerator from "@/components/print/PDFGenerator.vue";

export default defineComponent({
  name: "PrintModal",
  components: {
    PDFGenerator,
    PdfTemplate,
  },
  data: () => ({
    showPreview: ref(false),
    printElement: ref<HTMLElement>(),
  }),
  methods: {
    generate() {
      this.showPreview = true;
      if (!this.printElement) return;

      printJS({
        printable: "print-element",
        type: "html",
        scanStyles: true,
        style:
          "@page { size: A4 portrait; margin: 0; } body, html { margin:0px;padding:0px; }",
        targetStyles: ["*", "font-size"],
        targetStyle: [
          "padding-left",
          "padding-right",
          "padding-bottom",
          "padding-top",
        ],
        maxWidth: 1123,
        font_size: "undefined",
      });
    },
  },
});
